import { useState, useEffect, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import routes from "@/routes";

import { Flex, Typography, Spin, App, Space, Collapse, Button } from "antd";
import { ArrowLeftOutlined, SettingOutlined } from "@ant-design/icons";

import FormFieldsTable from "@/components/tables/FormFieldsTable";
import TransferFieldsModal from "@/components/modals/TransferFieldsModal";

import { getItem } from "@/api/definitions";

import { MODAL_TITLES } from "@/constants/definitions";

const { Title } = Typography;

const ObjectFormSettings = () => {
  const { id, type, formId } = useParams();
  const { message } = App.useApp();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const [isModalShow, setIsModalShow] = useState(false);

  const allFields = useMemo(() => {
    if (data && data.fields) {
      const { self, template } = data.fields;

      return [...(self || []), ...(template || [])];
    }

    return [];
  }, [data]);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const data = await getItem(id);

      setData(formateData(data));
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // initial fetch
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [id, type, formId]);

  const formateData = (data) => {
    const groups = data.groups || [];

    return {
      ...data,
      groups: groups
        .map((group) => {
          const res = {
            ...group,
            fields:
              group.fields?.map((field) => {
                return {
                  ...field,
                  name: field.caption,
                  uuid: field.field,
                };
              }) || [],
          };
          return res;
        })
        .sort((a, b) => a.idx - b.idx),
    };
  };

  const handleDeleteField = (item) => {
    console.log("delete", item);
  };

  const handleOpenTransferModal = (e, group) => {
    console.log("group", group);
    e.stopPropagation();
    setCurrentGroup(group);
    setIsModalShow(true);
  };

  const [currentGroup, setCurrentGroup] = useState();

  const handleChangeFields = () => {
    fetchData();
    setIsModalShow(false);
  };

  return (
    <>
      {isLoading ? (
        <div className="spin">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <Flex vertical gap={30}>
            <Link
              to={routes.administration.resourcesSettings.structures.definitionDetail(
                type,
                id
              )}
            >
              <Space>
                <ArrowLeftOutlined />
                <span>Назад в {MODAL_TITLES[type]}</span>
              </Space>
            </Link>
            {data && (
              <Flex gap={20} vertical>
                <Title level={2} className="no-margin">
                  Настройка формы отображения «{data.name}»
                </Title>

                <Collapse
                  bordered={false}
                  defaultActiveKey={data.groups.map((group) => group.uuid)}
                  items={data.groups.map((group) => {
                    return {
                      key: group.uuid,
                      label: (
                        <Title level={5} className="no-margin">
                          {group.name}
                        </Title>
                      ),
                      extra: !!group.idx && (
                        <Link
                          to="#"
                          onClick={(e) => handleOpenTransferModal(e, group)}
                        >
                          <Space>
                            <SettingOutlined />
                            Настроить
                          </Space>
                        </Link>
                      ),
                      children: (
                        <FormFieldsTable
                          data={group.fields}
                          pagination={false}
                          onDeleteItem={handleDeleteField}
                          hiddenControls
                        />
                      ),
                      style: {
                        marginBottom: 24,
                        background: "var(--color-white)",
                        borderRadius: "4px",
                        border: "none",
                      },
                    };
                  })}
                />

                <div>
                  <Button
                    type="primary"
                    onClick={(e) => handleOpenTransferModal(e, {})}
                  >
                    Добавить группу
                  </Button>
                </div>
              </Flex>
            )}
          </Flex>

          {isModalShow && (
            <TransferFieldsModal
              defId={id}
              maxIdx={data.groups.length}
              group={currentGroup}
              allFields={allFields}
              currentFields={currentGroup.fields}
              visible={isModalShow}
              onSave={handleChangeFields}
              onCancel={() => setIsModalShow(false)}
            />
          )}
        </>
      )}
    </>
  );
};

export default ObjectFormSettings;
